import {
  AnalyticsTopSellingProduct,
  IListAnalyticsExchange,
  IListBasketInsightResponse,
  ITopList,
  ListBasketInsightSort,
} from '@epicuro-next/data/reporting-api';
import { createAction, props } from '@ngrx/store';

import {
  IAnalyticsSignalrBaseEvent,
  ILiveViewersPayload,
} from '../models/signalr-events';

import { AnalyticsEntity } from './interfaces';

export const upsertAnalyticsEntities = createAction(
  '[Analytics Entities]: Upsert analytics entities',
  props<{ entities: AnalyticsEntity[] }>(),
);

export const loadListsReports = createAction(
  '[Analytics Entities]: Load lists reports',
  props<{ listIds: string[] }>(),
);

export const updateAnalyticsExchange = createAction(
  '[Analytics Entities]: Update list exchange value',
  props<{ exchange: IListAnalyticsExchange }>(),
);

export const loadListAnalytics = createAction(
  '[Analytics Entities]: Load List Analytics',
  props<{ listId: string; sortBy: ListBasketInsightSort }>(),
);

export const loadListLiveViewers = createAction(
  '[Analytics Entities]: Load live list viewers',
  props<{ listId: string }>(),
);

export const loadListBasketInsight = createAction(
  '[Analytics Entities]: Load List Analytics Basket Insight',
  props<{ listId: string; sortBy: ListBasketInsightSort }>(),
);

export const loadListBasketInsightSuccess = createAction(
  '[Analytics Entities]: Load List Analytics Basket Insight Success',
  props<{ payload: IListBasketInsightResponse }>(),
);

export const reportDataReceived = createAction(
  '[Analytics Entities]: Real-time report data received',
  props<{ event: IAnalyticsSignalrBaseEvent }>(),
);

export const addLiveUsersToListEntity = createAction(
  '[Analytics Entities]: Live viewers for list',
  props<{ usersPayload: ILiveViewersPayload }>(),
);

export const setHottestLists = createAction(
  '[Analytics Entities]: Set hottest lists',
  props<{ topLists: ITopList[] }>(),
);

export const loadHotListAnalytics = createAction(
  '[Analytics Entities]: Load hot list analytics',
);

export const upsertAnalyticsEntityTopSellingProducts = createAction(
  '[Analytics Entities]: Upsert top selling products',
  props<{ products: AnalyticsTopSellingProduct[]; listId: string }>(),
);
